import { render, staticRenderFns } from "./RecentBlogPostsSectionModule.vue?vue&type=template&id=be5c2850&"
import script from "./RecentBlogPostsSectionModule.vue?vue&type=script&lang=js&"
export * from "./RecentBlogPostsSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports